import { render, staticRenderFns } from "./BibleCloudApp.vue?vue&type=template&id=8998134e&scoped=true&"
import script from "./BibleCloudApp.vue?vue&type=script&lang=js&"
export * from "./BibleCloudApp.vue?vue&type=script&lang=js&"
import style0 from "./BibleCloudApp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BibleCloudApp.vue?vue&type=style&index=1&id=8998134e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8998134e",
  null
  
)

export default component.exports